import { alpha } from "@mui/material/styles";
import { Shadows } from "@mui/material/styles";
import { GREY, PRIMARY } from "./palette";

// Soft, layered shadows in the Minimal UI kit style (grey-based, low opacity).
const COLOR = GREY[500];

function softShadow(y: number, blur: number, spread: number, opacity: number): string {
  return `0px ${y}px ${blur}px ${spread}px ${alpha(COLOR, opacity)}`;
}

const base: string[] = [
  "none",
  softShadow(1, 2, 0, 0.16),
  softShadow(2, 4, 0, 0.16),
  softShadow(3, 6, 0, 0.14),
  softShadow(4, 8, 0, 0.14),
  softShadow(5, 10, 0, 0.14),
  softShadow(6, 12, 0, 0.12),
  softShadow(7, 14, 0, 0.12),
  softShadow(8, 16, 0, 0.12),
  softShadow(9, 18, 0, 0.12),
  softShadow(10, 20, 0, 0.11),
  softShadow(11, 22, 0, 0.11),
  softShadow(12, 24, 0, 0.11),
  softShadow(13, 26, 0, 0.1),
  softShadow(14, 28, 0, 0.1),
  softShadow(15, 30, 0, 0.1),
  softShadow(16, 32, 0, 0.1),
  softShadow(17, 34, 0, 0.09),
  softShadow(18, 36, 0, 0.09),
  softShadow(19, 38, 0, 0.09),
  softShadow(20, 40, 0, 0.09),
  softShadow(21, 42, 0, 0.08),
  softShadow(22, 44, 0, 0.08),
  softShadow(23, 46, 0, 0.08),
  softShadow(24, 48, 0, 0.08),
];

export const shadows = base as Shadows;

// Named custom shadows for component overrides.
export const cardShadow = `0 0 2px 0 ${alpha(GREY[500], 0.2)}, 0 12px 24px -4px ${alpha(GREY[500], 0.12)}`;
export const dropdownShadow = `-20px 20px 40px -4px ${alpha(GREY[500], 0.24)}`;
export const dialogShadow = `-40px 40px 80px -8px ${alpha(GREY[500], 0.24)}`;
export const primaryShadow = `0 8px 16px 0 ${alpha(PRIMARY.main, 0.24)}`;
